module.exports = __webpack_public_path__ + "img/102.94336b92.jpg";